import script from "./UploadFilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFilePage.vue?vue&type=script&setup=true&lang=js"

import "./UploadFilePage.vue?vue&type=style&index=0&id=7cb7804b&lang=scss&scoped=true"

import exportComponent from "H:\\crm\\crm_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb7804b"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerOrbit from 'quasar/src/components/spinner/QSpinnerOrbit.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QForm,QToolbarTitle,QUploader,QCardActions,QBtn,QInnerLoading,QSpinnerOrbit});
